<div class="multimedia-controls-container presentation_toolbar_v1" [ngClass]="{ dropdownOpen: isDropdownOpen() }">
  <div class="flex items-center multimedia-controls tablet-w-full mobile-w-full m-t-10">
    <!-- Multimedia Controls -->
    <div class="tablet-w-full mobile-w-full">
      <div class="fab-options">
        <div class="opacity-background responsive-controls"></div>
        <div class="flex buttons-group multimedia-toolbar items-center justify-between w-full">
          <!-- #region LEFT BUTTONS -->
          <div
            id="divBtnFlex"
            class="controls-container flex left-buttons"
            [ngClass]="{ screenShareActive: screenShareActive() }"
          >
            <div class="button-wrapper">
              <div
                class="fab-icon-holder"
                [matTooltip]="audioTooltip()"
                [ngClass]="{
                  'engaged-button': !isMicEnabled() && audioPermissionGranted(),
                  opacity: isCountdownPage(),
                  'disabled-click': isCountdownPage(),
                }"
              >
                <button
                  aria-label="Toggle Microphone"
                  id="btnRoomMic"
                  class="material-icons"
                  data-testid="btn-toggle-mic"
                  [ngClass]="{ disabled: isInteractionDisabled(), 'permission-denied': !audioPermissionGranted() }"
                  (click)="clickedToggleMic()"
                >
                  <mat-icon class="denied-icon" *ngIf="!audioPermissionGranted()">info</mat-icon>
                  <span *ngIf="micButtonAvailableAndEnabled(); then micon; else micoff"></span>
                  <ng-template #micon><mat-icon>mic</mat-icon></ng-template>
                  <ng-template #micoff><mat-icon>mic_off</mat-icon></ng-template>
                </button>
                <app-multimedia-dropdown
                  *ngIf="audioPermissionGranted()"
                  [type]="MultimediaType.AUDIO"
                  [isVideoEnabled]="isVideoEnabled()"
                  [isMicEnabled]="isMicEnabled()"
                  (showDropdownEvent)="showDropdownEvent($event)"
                >
                </app-multimedia-dropdown>
              </div>
            </div>

            <div class="button-wrapper">
              <div
                class="fab-icon-holder"
                [ngClass]="{
                  'engaged-button': !isVideoEnabled() && videoPermissionGranted(),
                  opacity: isCountdownPage(),
                  'disabled-click': isCountdownPage(),
                }"
                [matTooltip]="cameraTooltip()"
              >
                <button
                  aria-label="Toggle Camera"
                  id="btnRoomVideo"
                  class="material-icons"
                  data-testid="btn-toggle-video"
                  [ngClass]="{
                    'permission-denied': !videoPermissionGranted(),
                    disabled: (isCameraDisabled() || isCameraUnreadable()) && videoPermissionGranted(),
                  }"
                  (click)="clickedToggleVideo()"
                >
                  <mat-icon class="denied-icon" *ngIf="!videoPermissionGranted()">info</mat-icon>
                  <span *ngIf="videoButtonAvailableAndEnabled(); then videoon; else videooff"></span>
                  <ng-template #videoon><mat-icon>videocam</mat-icon></ng-template>
                  <ng-template #videooff><mat-icon>videocam_off</mat-icon></ng-template>
                </button>
                <app-multimedia-dropdown
                  *ngIf="areCamerasAvailable() && !isCameraDisabled() && videoPermissionGranted()"
                  [type]="MultimediaType.CAMERA"
                  [isVideoEnabled]="isVideoEnabled()"
                  [isMicEnabled]="isMicEnabled()"
                  (showDropdownEvent)="showDropdownEvent($event)"
                >
                </app-multimedia-dropdown>
              </div>
            </div>
            <!-- #region Volume control -->
            <div
              class="button-wrapper volume-control flex"
              [ngClass]="{
                'display-none': isVolumeControlVisible(),
                open: volumeControlOpen(),
                big: isHost() && isPremiumPlaylist() && !someoneIsPerforming(),
                opacity: isOrientationExperience(),
                'disabled-click': isOrientationExperience(),
              }"
            >
              <div class="bullet-area">
                <app-presentation-sound-icon
                  [sliderVolumeLevel]="sliderVolumeLevel()"
                  (emitClickedToggleMusic)="clickedToggleMusic()"
                ></app-presentation-sound-icon>
                <div class="controllers">
                  <div
                    class="tag-name"
                    [ngClass]="{ marquee: isPremiumPlaylist() || (someoneIsPerforming() && !isUserPresenting()) }"
                  >
                    <p *ngIf="someoneIsPerforming() && !isUserPresenting()">{{ presenterName() }}</p>
                    <p *ngIf="isUserPresenting()">Crowd Volume</p>
                    <p *ngIf="!someoneIsPerforming()">
                      <span>Playlist: {{ playlist()?.name }}</span>
                      <span *ngIf="isPremiumPlaylist() && playlistService.currentTrack().title">
                        <mat-icon>music_note</mat-icon> {{ playlistService.currentTrack().title }}
                      </span>
                      <span *ngIf="isPremiumPlaylist() && playlistService.currentTrack().artists">
                        <mat-icon svgIcon="MUSIC_ARTIST"></mat-icon> {{ playlistService.currentTrack().artists }}
                      </span>
                      <span *ngIf="isPremiumPlaylist() && playlistService.currentTrack().album">
                        <mat-icon>album</mat-icon> {{ playlistService.currentTrack().album }}
                      </span>
                    </p>
                  </div>
                  <mat-slider
                    aria-label="Volume control"
                    style="width: 100%"
                    id="slider"
                    [min]="0"
                    [max]="maxSliderVolume()"
                    (click)="sliderClick($event)"
                    #ngSlider
                    ><input
                      matSliderThumb
                      [value]="sliderVolumeLevel()"
                      (change)="blurSliderAfterChange({ value: ngSliderThumb.value })"
                      #ngSliderThumb="matSliderThumb"
                      (input)="sliderDidChange({ value: ngSliderThumb.value })"
                    />
                  </mat-slider>
                </div>
                <div
                  class="play-next fab-icon-holder"
                  *ngIf="isHost() && isPremiumPlaylist() && !someoneIsPerforming()"
                >
                  <button
                    aria-label="Next Song"
                    id="btnMusicFoward"
                    mat-mini-fab
                    color=""
                    class="material-icons"
                    aria-label="Next Song"
                    data-testid="btn-music-foward"
                    (click)="clickedNextSong()"
                  >
                    <mat-icon matTooltip="Skip song for room">fast_forward</mat-icon>
                  </button>
                </div>
              </div>
            </div>
            <!-- #endregion -->
          </div>
          <!-- #endregion -->

          <!-- #region CENTER BUTTONS -->
          <div
            id="divBtnCenter"
            class="center-buttons flex"
            [ngClass]="{ opacity: isOrientationExperience(), 'disabled-click': isOrientationExperience() }"
          >
            <div class="group-info-container" *ngIf="!isUserPresenting() && !isPresentationActive()">
              @if (groupSoftCap() && specialAccessGroups()) {
                <div class="group-info" id="groupInfo">
                  @if (!isSagModalOpen()) {
                    <div
                      class="group-details"
                      [ngClass]="{ hidden: groupParticipantDefaultCount() <= 1, 'group-details-full': groupFull() }"
                    >
                      <div class="detail-text" [ngClass]="{ 'full-group ': groupFull() }">
                        @if (isMyUserInSag()) {
                          <mat-icon class="sag-icon" svgIcon="DIAMOND_ACCESS"></mat-icon>
                        }
                        <div class="detail-value-description">Group Size:</div>
                        @if (player()?.groupHardLimitExceeded) {
                          <div class="detail-value full-group-text">Group Full</div>
                        } @else {
                          <div class="detail-value">{{ groupParticipantDefaultCount() }}</div>
                          <div class="detail-value-connector">of</div>
                          <div class="detail-value">{{ groupSoftCapValue() }}</div>
                        }
                      </div>
                      @if (groupExtraParticipantsCount() > 0 && !player()?.groupHardLimitExceeded) {
                        <div class="additional-info">
                          <div class="additional-users" [ngClass]="{ 'full-group ': groupFull() }">
                            + {{ groupExtraParticipantsCount() }}
                            @if (groupFull()) {
                              <span class="spots-left full-group">Max</span>
                            }
                          </div>
                        </div>
                      } @else {
                        <div class="button-container"></div>
                      }
                    </div>
                  } @else {
                    <div class="group-details">
                      <div class="sag-content">
                        <mat-icon class="sag-icon" svgIcon="DIAMOND_ACCESS"></mat-icon>
                        <span> Special Access Group </span>
                      </div>
                    </div>
                  }
                  @if (groupSoftCap() && groupParticipantDefaultCount() > 1) {
                    <div class="connector-svg-desktop">
                      <svg
                        width="120"
                        height="110"
                        viewBox="0 0 120 110"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16345 32 16 32H18C32.9117 32 45 44.0883 45 59V64C45 78.9117 57.0883 91 72 91H73C87.9117 91 100 78.9117 100 64V58C100 43.6406 111.641 32 126 32C134.837 32 142 24.8366 142 16C142 7.16344 134.837 0 126 0H16Z"
                          fill="#5C6C96"
                          fill-opacity="1"
                        />
                      </svg>
                    </div>
                  }

                  <app-presentation-menu-dropdown
                    [type]="presentationMenuType.GROUP"
                    [user]="user()"
                    [activeGroup]="!!(groupParticipantDefaultCount() > 1)"
                    (showDropdownEvent)="showDropdownEvent($event)"
                    (dropdownSelected)="closeOtherDropdowns(presentationMenuType.GROUP)"
                  ></app-presentation-menu-dropdown>
                </div>
              } @else {
                <app-presentation-menu-dropdown
                  [type]="presentationMenuType.GROUP"
                  [user]="user()"
                  [activeGroup]="false"
                  (showDropdownEvent)="showDropdownEvent($event)"
                  (dropdownSelected)="closeOtherDropdowns(presentationMenuType.GROUP)"
                ></app-presentation-menu-dropdown>
              }

              <div *ngIf="!isGroupShareRecording()">
                <app-presentation-menu-dropdown
                  [type]="presentationMenuType.PRESENTATION"
                  [user]="user()"
                  (showDropdownEvent)="showDropdownEvent($event)"
                  (dropdownSelected)="closeOtherDropdowns(presentationMenuType.PRESENTATION)"
                ></app-presentation-menu-dropdown>
              </div>
            </div>

            <!-- End other's presentation -->
            <button
              type="button"
              class="button-wrapper btn-end-presentation mat-button standard-button rounded bg-color-orange-crayola"
              data-testid="btn-end-presentation"
              (click)="endPresentation()"
              *ngIf="isHost() && isPresentationActive() && !isUserPresenting()"
              [disabled]="isLoadingPresentation()"
            >
              @if (!isLoadingPresentation()) {
                {{ presentersCount() === 1 ? 'End Presentation' : 'Stop Presenting' }}
              } @else {
                <div class="loader-container">
                  <app-loading />
                </div>
              }
            </button>

            <!-- If user is watching a presentation but not presenting -->
            <div class="flex" *ngIf="!isUserPresenting() && isPresentationActive()">
              <!-- Join presentation -->
              <div class="button-wrapper">
                <ng-container
                  *ngIf="isPresentationActive() && !isUserPresenting() && (isHost() || allowAnyonePresent())"
                >
                  <span class="html-tooltip">
                    <button
                      aria-label="Join presentation"
                      data-testid="button-join-presentation"
                      class="btn-join-presentation btn-round-icon"
                      matRipple
                      (click)="handleQuickJoinPresentation()"
                      [class.disabled]="isPresentationFull() || isUserSharingToGroup()"
                      [matTooltip]="getTooltipText()"
                    >
                      <i class="btn-icon">
                        <mat-icon svgIcon="JOIN_PRESENTATION"></mat-icon>
                      </i>
                    </button>
                  </span>
                </ng-container>
              </div>
              <!-- PTT -->
              <div
                class="button-wrapper"
                *ngIf="showSaySomethingButton()"
                matTooltip="Another user is currently speaking. Please wait till they have finished."
                [matTooltipDisabled]="!disableSaySomethingButton()"
              >
                <button
                  mat-button
                  class="say-something-btn audio-mode-btn bg-color-success text-color-moss"
                  data-testid="say-something-btn"
                  [disabled]="disableSaySomethingButton()"
                  (click)="isSayingSomething() ? stopSayingSomething() : saySomething()"
                >
                  {{ isSayingSomething() ? 'Stop speaking' : 'Speak' }}
                </button>
              </div>

              <div
                class="button-wrapper"
                [ngClass]="{ 'others-presenting': isHost() && isPresentationActive() && !isUserPresenting() }"
                *ngIf="isPresentationActive() && !isUserPresenting() && showQAButton()"
                matTooltip="{{ raiseHandButtonTooltip() }}"
              >
                <!-- Q&A Raise Hand -->
                <button
                  mat-button
                  class="raise-hand-btn audio-mode-btn bg-color-success text-color-moss"
                  data-testid="raise-hand-btn"
                  [disabled]="disableQAButton()"
                  (click)="handleQAButtonClick()"
                >
                  {{ raiseHandButtonText() }}
                </button>
              </div>
            </div>

            <!-- If presentation is active -->
            <div class="flex" *ngIf="isPresentationActive()">
              <!-- If user is presenting (not to group) -->
              <div class="flex" *ngIf="isUserPresenting() && !isUserSharingToGroup()">
                <!-- Share screen while presenting -->
                <div class="button-wrapper">
                  <div class="fab-icon-holder">
                    <ng-container
                      *ngIf="
                        (!isUserSharingScreen() && !isHost() && !activeMediaEmbed()) ||
                        (!screenShareActive() && !activeMediaEmbed())
                      "
                    >
                      <button
                        #screenShareButton
                        aria-label="Screen Share"
                        matTooltip="Screen Share"
                        id="btnScreenShare"
                        class="material-icons"
                        data-testid="btn-screen-share"
                        [disabled]="screenShareActive()"
                        [class.disabled]="screenShareActive()"
                        (click)="
                          enhancedScreenShare()
                            ? shareScreenMenu.set(!shareScreenMenu())
                            : handleQuickScreenShare(shareType.SCREEN)
                        "
                      >
                        <mat-icon svgIcon="SHARE_SCREEN"></mat-icon>
                      </button>

                      <div
                        #screenShareDropdown
                        *ngIf="shareScreenMenu"
                        class="dropdown"
                        [ngClass]="{ active: shareScreenMenu() && !screenShareActive() }"
                      >
                        <div class="options">
                          <div
                            class="button-wrapper first-wrapper"
                            *ngIf="(canScreenShare() || isUserPresenting()) && !activeMediaEmbed()"
                          >
                            <button
                              data-testid="share-screen-btn"
                              class="option present-menu"
                              (click)="handleQuickScreenShare(shareType.SCREEN)"
                            >
                              <mat-icon>screen_share</mat-icon>
                              <span
                                class="option-name"
                                matTooltip="Share Screen to Scootaverse"
                                matTooltipPosition="right"
                                >Share screen</span
                              >
                            </button>
                          </div>
                          <div
                            class="button-wrapper last-wrapper"
                            *ngIf="canScreenShare() && enhancedScreenShare() && !activeMediaEmbed()"
                          >
                            <button
                              data-testid="share-screen-btn"
                              class="option present-menu"
                              (click)="handleQuickScreenShare(shareType.HDSCREEN)"
                            >
                              <mat-icon>music_video</mat-icon>
                              <span
                                class="option-name"
                                matTooltip="Share HD Screen for Video to Scootaverse"
                                matTooltipPosition="right"
                                >Share video stream</span
                              >
                            </button>
                          </div>
                          <div class="button-wrapper last-wrapper" *ngIf="!activeMediaEmbed()">
                            <button
                              data-testid="share-screen-btn"
                              class="option present-menu"
                              (click)="handleQuickMediaShare(false)"
                            >
                              <mat-icon svgIcon="EMBED_VIDEO"></mat-icon>
                              <span
                                class="option-name"
                                matTooltip="Share an embedded Video to room"
                                matTooltipPosition="right"
                                >Share video link</span
                              >
                            </button>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container
                      *ngIf="isUserSharingScreen() || (screenShareActive() && isHost()) || activeMediaEmbed()"
                    >
                      <div *ngIf="displayScreenShareMessage()" class="screen-share-message">
                        <mat-icon svgIcon="PRESENT_TO_ALL"></mat-icon>
                        <span>
                          {{ activeMediaEmbed() ? 'You are sharing an embedded video' : 'You are sharing your screen' }}
                        </span>
                      </div>
                      <span [matTooltip]="activeMediaEmbed() ? 'Stop sharing embedded video' : 'Stop screen share'">
                        <button
                          aria-label="Stop Screen Share"
                          id="btnStopScreenShare"
                          data-testid="btn-stop-screen-share"
                          mat-mini-fab
                          class="material-icons"
                          (click)="handleStopScreenShare()"
                        >
                          <mat-icon svgIcon="STOP_SHARE_SCREEN"></mat-icon>
                        </button>
                      </span>
                    </ng-container>
                  </div>
                </div>

                <!-- Stop presenting -->
                <div class="button-wrapper">
                  <button
                    type="button"
                    mat-button
                    id="end-performance"
                    data-testid="btn-end-performance"
                    class="stop-presenting-btn standard-button rounded bg-color-orange-crayola"
                    (click)="stopPresenting()"
                    *ngIf="isUserPresenting()"
                    [disabled]="isLoadingPresentation()"
                  >
                    @if (!isLoadingPresentation()) {
                      {{ presentersCount() === 1 ? 'End Presentation' : 'Stop Presenting' }}
                    } @else {
                      <div class="loader-container">
                        <app-loading />
                      </div>
                    }
                  </button>
                </div>
              </div>

              <!-- If it is a presenter: Manual record -->
              <div
                class="button-wrapper"
                *ngIf="isHost() || isUserPresenting()"
                [matTooltip]="meetingRecordingTooltip()"
                id="buttonWrapperHost"
              >
                <div class="fab-icon-holder">
                  <button
                    (click)="presentationRecorderService.handleRecordPresentation()"
                    id="btnManualRecord"
                    data-testid="btn-manual-record"
                    mat-mini-fab
                    class="material-icons fill-icon"
                    [ngClass]="{ recording: isPresentationRecording() || isWideRecording() }"
                    [disabled]="isWideRecording()"
                  >
                    <mat-icon>fiber_manual_record</mat-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- If User is sharing to Group -->
            <div class="flex" *ngIf="isUserSharingToGroup()">
              <!-- Manual group record -->
              <div
                class="button-wrapper"
                *ngIf="isHost()"
                matTooltip="{{
                  isWideRecording()
                    ? 'Meeting wide recording in progress. Recording cannot be turned off at this time.'
                    : isGroupShareRecording()
                      ? 'End Recording'
                      : 'Record Group Screen Sharing'
                }}"
              >
                <div class="fab-icon-holder">
                  <button
                    (click)="handleRecordGroupSharing()"
                    attr.aria-label="{{ isGroupShareRecording() ? 'End Recording' : 'Record Group Screen Sharing' }}"
                    data-testid="btn-manual-group-record"
                    mat-mini-fab
                    class="material-icons fill-icon"
                    [ngClass]="{ recording: isGroupShareRecording() || isWideRecording() }"
                    [disabled]="isWideRecording()"
                  >
                    <mat-icon>fiber_manual_record</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- #endregion -->

          <!-- #region RIGHT BUTTONS -->
          <div id="divBtnRight" class="right-buttons flex">
            <div
              class="button-wrapper"
              [matTooltip]="disableCaptureDebugData() ? 'Capture Debug Data in progress' : 'Capture Debug Data'"
              *ngIf="allowDebugger"
              [ngClass]="{ opacity: isOrientationExperience(), 'disabled-click': isOrientationExperience() }"
            >
              <div class="fab-icon-holder">
                <button
                  id="btnDebug"
                  mat-mini-fab
                  class="material-icons"
                  data-testid="btn-Debug"
                  [disabled]="disableCaptureDebugData()"
                  (click)="captureDebugData()"
                >
                  <mat-icon class="bug-icon">bug_report</mat-icon>
                </button>
              </div>
            </div>

            <div
              #emojiPickerButton
              class="button-wrapper"
              *ngIf="emotes"
              [ngClass]="{ opacity: isOrientationExperience(), 'disabled-click': isOrientationExperience() }"
            >
              <div class="fab-icon-holder" matTooltip="Reactions" [ngClass]="{ 'engaged-button': emotesPickerOpen() }">
                <button
                  title="Reactions"
                  id="btnEmotes"
                  mat-mini-fab
                  class="material-icons"
                  data-testid="btn-emotes"
                  (click)="toggleEmotePicker($event)"
                >
                  @if (emotesPickerOpen()) {
                    <mat-icon class="emoji-icon-wrapper" svgIcon="ADD_EMOJI_ENABLED"></mat-icon>
                  } @else {
                    <mat-icon class="emoji-icon-wrapper" svgIcon="ADD_EMOJI_DISABLED"></mat-icon>
                  }
                </button>
              </div>
              <div #emojiPicker>
                <emoji-mart
                  class="emoji-mart"
                  *ngIf="emotes() && emotesPickerOpen()"
                  (emojiClick)="addEmoji($event)"
                  [darkMode]="false"
                  [showPreview]="false"
                  color="#0c58c6"
                  title="Pick your emoji…"
                  emoji="grinning"
                  set="apple"
                  [recent]="defaultEmojis"
                ></emoji-mart>
              </div>
            </div>

            <div
              class="button-wrapper"
              *ngIf="isSearchEnabled()"
              [ngClass]="{ opacity: isOrientationExperience(), 'disabled-click': isOrientationExperience() }"
            >
              <div
                class="fab-icon-holder"
                matTooltip="Search"
                [ngClass]="{ 'engaged-button': searchParticipantIsOpen() }"
              >
                <button
                  id="btnSearch"
                  mat-mini-fab
                  class="material-icons"
                  data-testid="btn-search"
                  (click)="toggleSearchRoom()"
                >
                  <mat-icon>search</mat-icon>
                </button>
              </div>
              <app-search-participants *ngIf="searchParticipantIsOpen()"></app-search-participants>
            </div>

            <div
              *ngIf="showChat()"
              class="responsive-controls button-wrapper chat-button"
              [matTooltip]="!isChatOpen() ? 'Open Chat' : 'Close Chat'"
              [ngClass]="{ opacity: isOrientationExperience(), 'disabled-click': isOrientationExperience() }"
            >
              <div
                class="fab-icon-holder"
                [ngClass]="{ 'engaged-button': isChatOpen() }"
                [matBadge]="getBadgeCountDisplay()"
                [matBadgeHidden]="badgeHidden()"
              >
                <button id="btnRoomChat" class="material-icons" (click)="toggleChat()" data-testid="btn-toggle-chat">
                  <mat-icon class="chat-icon">chat_bubble</mat-icon>
                </button>
              </div>
            </div>
            <div
              class="button-wrapper"
              [ngClass]="{
                opacity: isOrientationExperience() && !openMiniMap(),
                'disabled-click': isOrientationExperience(),
              }"
            >
              <app-social-mini-map
                class="mini-map"
                #minimap
                nativeCursor
                [user]="user()"
                *ngIf="social() && inSocial()"
                [ngClass]="{
                  'hide-responsive-element': sideSectionService.sideContainerType !== sideContainerType.NONE,
                }"
              >
              </app-social-mini-map>
              <!-- dummy map button for onboarding -->
              <div class="button-wrapper presentation-v1">
                <div *ngIf="isOrientationExperience()" class="fab-icon-holder">
                  <button mat-mini-fab class="material-icons">
                    <mat-icon>map</mat-icon>
                  </button>
                </div>
              </div>
              <!-- end dummy -->
            </div>
            <div
              *ngIf="showClosedCaptionsButton()"
              class="responsive-controls button-wrapper"
              [ngClass]="{ opacity: isOrientationExperience(), 'disabled-click': isOrientationExperience() }"
              [matTooltip]="!isClosedCaptionsEnabled() ? 'Enable Closed Captions' : 'Disable Closed Captions'"
            >
              <div class="fab-icon-holder" [ngClass]="{ 'engaged-button': isClosedCaptionsEnabled() }">
                <button
                  id="btnRoomChat"
                  class="material-icons"
                  (click)="toggleClosedCaptions()"
                  data-testid="btn-toggle-chat"
                >
                  <mat-icon>closed_caption</mat-icon>
                </button>
              </div>
            </div>

            <div
              class="button-wrapper"
              [matTooltip]="isHelpModalOpen() ? (showKnowledgeBaseChatbot() ? undefined : 'Close Help') : 'Open Help'"
              [ngClass]="{ opacity: isOrientationExperience(), 'disabled-click': isOrientationExperience() }"
            >
              <div #helpButton class="fab-icon-holder" [ngClass]="{ 'engaged-button': isHelpModalOpen() }">
                <button
                  aria-label="Help"
                  id="btnHelp"
                  mat-mini-fab
                  class="material-icons"
                  (click)="openHelpModal()"
                  data-testid="btn-open-help"
                >
                  <mat-icon>question_mark</mat-icon>
                </button>
              </div>
              <div
                #aiChatbot
                [ngClass]="{ 'knowledge-base-chatbot-position-open': showKnowledgeBaseChatbot() }"
                class="knowledge-base-chatbot-position"
              >
                <app-knowledge-base-chatbot></app-knowledge-base-chatbot>
              </div>
            </div>

            <div
              class="button-wrapper"
              [ngClass]="{ opacity: isOrientationExperience(), 'disabled-click': isOrientationExperience() }"
            >
              <div
                class="fab-icon-holder"
                [ngClass]="{ 'engaged-button': sideSectionService.sideContainerType === sideContainerType.ACTION_MENU }"
              >
                <button
                  mat-mini-fab
                  id="btnSideMenuBar"
                  data-testid="side-menu-button"
                  class="material-icons"
                  (click)="toggleMenu()"
                  [matTooltip]="
                    sideSectionService.sideContainerType === sideContainerType.ACTION_MENU ? 'Close Menu' : 'Open Menu'
                  "
                >
                  <mat-icon>{{
                    sideSectionService.sideContainerType === sideContainerType.ACTION_MENU ? 'close' : 'more_horiz'
                  }}</mat-icon>
                </button>
              </div>
            </div>
          </div>
          <!-- #endregion -->
        </div>
      </div>
    </div>
  </div>

  <div
    id="multimedia-controls-mobile"
    class="multimedia-controls-mobile"
    [ngClass]="{
      'multimedia-controls-mobile-not-mingle-mode':
        (isPresentationActive() && !isLoadingPresentation()) || isWaitingForHost(),
      'is-mobile-not-fullscreen': !isMobileFullscreen(),
    }"
  >
    <div class="mobile-toolbar">
      @if (!isPresentationActive()) {
        <!-- Chat-->
        <div class="button-wrapper">
          <div
            *ngIf="showChat()"
            class="responsive-controls button-wrapper chat-button"
            [matTooltip]="!isChatOpen() ? 'Open Chat' : 'Close Chat'"
            [ngClass]="{ opacity: isOrientationExperience(), 'disabled-click': isOrientationExperience() }"
          >
            <div
              class="fab-icon-holder"
              [ngClass]="{ 'engaged-button': isChatOpen() }"
              [matBadge]="getBadgeCountDisplay()"
              [matBadgeHidden]="badgeHidden()"
            >
              <button
                title="Chat"
                id="btnRoomChat"
                class="material-icons chat-button"
                (click)="toggleChat()"
                data-testid="btn-toggle-chat"
              >
                <mat-icon svgIcon="CHAT_MOBILE"></mat-icon>
              </button>
            </div>
          </div>
        </div>
      }

      <!-- Audio/Mic-->
      <div class="button-wrapper">
        <div
          class="fab-icon-holder"
          [matTooltip]="audioTooltip()"
          [ngClass]="{ 'engaged-button': !isMicEnabled() && audioPermissionGranted() }"
        >
          <button
            id="btnMobileRoomMic"
            class="material-icons"
            data-testid="btn-mobile-toggle-mic"
            [ngClass]="{ disabled: isInteractionDisabled(), 'permission-denied': !audioPermissionGranted() }"
            (click)="clickedToggleMic()"
          >
            <mat-icon class="denied-icon" *ngIf="!audioPermissionGranted()">info</mat-icon>
            <span *ngIf="micButtonAvailableAndEnabled(); then micon; else micoff"></span>
            <ng-template #micon><mat-icon>mic</mat-icon></ng-template>
            <ng-template #micoff><mat-icon>mic_off</mat-icon></ng-template>
          </button>
        </div>
      </div>

      <!-- Group info-->
      <div class="group-info-container button-wrapper" *ngIf="!isUserPresenting() && !isPresentationActive()">
        @if (groupSoftCap() && specialAccessGroups()) {
          <div class="group-info" id="groupInfo">
            <div
              class="group-details"
              [ngClass]="{ hidden: groupParticipantDefaultCount() <= 1, 'group-details-full': groupFull() }"
            >
              @if (isMyUserInSag()) {
                <div class="is-sag-mobile">
                  <mat-icon svgIcon="DIAMOND_ACCESS"></mat-icon>
                </div>
              }
              <div class="detail-text" [ngClass]="{ 'full-group ': groupFull() }">
                <div class="detail-value-description">Group Size:</div>
                @if (player()?.groupHardLimitExceeded) {
                  <div class="detail-value full-group-text">Group Full</div>
                } @else {
                  <div class="detail-value">{{ groupParticipantDefaultCount() }}</div>
                  <div class="detail-value-connector">of</div>
                  <div class="detail-value">{{ groupSoftCapValue() }}</div>
                }
              </div>
              @if (groupExtraParticipantsCount() > 0 && !player()?.groupHardLimitExceeded) {
                <div class="additional-info">
                  <div class="additional-users" [ngClass]="{ 'full-group ': groupFull() }">
                    + {{ groupExtraParticipantsCount() }}
                    @if (groupFull()) {
                      <span class="spots-left full-group">Max</span>
                    }
                  </div>
                </div>
              }
            </div>
            @if (groupSoftCap() && groupParticipantDefaultCount() > 1) {
              <div class="connector-svg">
                <svg width="200" height="90" viewBox="0 0 200 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16345 32 16 32H18C32.9117 32 45 44.0883 45 59V64C45 78.9117 57.0883 91 72 91H73C87.9117 91 100 78.9117 100 64V58C100 43.6406 111.641 32 126 32C134.837 32 142 24.8366 142 16C142 7.16344 134.837 0 126 0H16Z"
                    fill="#5C6C96"
                    fill-opacity="1"
                  />
                </svg>
              </div>
            }
            <div class="button-dropdown">
              <app-presentation-menu-dropdown
                [type]="presentationMenuType.GROUP"
                [user]="user()"
                [activeGroup]="!!(groupParticipantDefaultCount() > 1)"
                (showDropdownEvent)="showDropdownEvent($event)"
                (dropdownSelected)="closeOtherDropdowns(presentationMenuType.GROUP)"
              ></app-presentation-menu-dropdown>
            </div>
          </div>
        } @else {
          <app-presentation-menu-dropdown
            [type]="presentationMenuType.GROUP"
            [user]="user()"
            [activeGroup]="false"
            (showDropdownEvent)="showDropdownEvent($event)"
            (dropdownSelected)="closeOtherDropdowns(presentationMenuType.GROUP)"
          ></app-presentation-menu-dropdown>
        }
      </div>

      <!-- Video wrapper -->
      <div class="button-wrapper">
        <div
          class="fab-icon-holder"
          [ngClass]="{ 'engaged-button': !isVideoEnabled() && videoPermissionGranted() }"
          [matTooltip]="cameraTooltip()"
        >
          <button
            id="btnMobileRoomVideo"
            class="material-icons"
            data-testid="btn-mobile-toggle-video"
            [ngClass]="{
              'permission-denied': !videoPermissionGranted(),
              disabled: (isCameraDisabled() || isCameraUnreadable()) && videoPermissionGranted(),
            }"
            (click)="clickedToggleVideo()"
          >
            <mat-icon class="denied-icon" *ngIf="!videoPermissionGranted()">info</mat-icon>
            <span *ngIf="videoButtonAvailableAndEnabled(); then videoon; else videooff"></span>
            <ng-template #videoon><mat-icon>videocam</mat-icon></ng-template>
            <ng-template #videooff><mat-icon>videocam_off</mat-icon></ng-template>
          </button>
        </div>
      </div>

      @if (isPresentationActive()) {
        @if (!isUserPresenting()) {
          <div
            class="button-wrapper say-something"
            *ngIf="showSaySomethingButton()"
            matTooltip="Another user is currently speaking. Please wait till they have finished."
            [matTooltipDisabled]="!disableSaySomethingButton()"
          >
            <button
              mat-button
              class="say-something-btn audio-mode-btn bg-color-success text-color-moss"
              data-testid="say-something-btn-mobile"
              [disabled]="disableSaySomethingButton()"
              (click)="isSayingSomething() ? stopSayingSomething() : saySomething()"
            >
              {{ isSayingSomething() ? 'Stop speaking' : 'Speak' }}
            </button>
          </div>
        } @else {
          <!-- Stop presenting -->
          <div class="button-wrapper">
            <button
              type="button"
              mat-button
              id="end-performance"
              data-testid="btn-end-performance"
              class="stop-presenting-btn standard-button rounded bg-color-orange-crayola"
              (click)="stopPresenting()"
              *ngIf="isUserPresenting()"
              [disabled]="isLoadingPresentation()"
            >
              @if (!isLoadingPresentation()) {
                {{ presentersCount() === 1 ? 'End Presentation' : 'Stop Presenting' }}
              } @else {
                <div class="loader-container">
                  <app-loading />
                </div>
              }
            </button>
          </div>
        }

        <!-- This button is waiting the gallery refactor to a mobile version -->
        <!-- This false verification will be in place until it is decided about this refactor, if it will happen-->
        @if (false) {
          <div class="button-wrapper">
            <div class="fab-icon-holder">
              <button
                mat-mini-fab
                id="btnOpenMobileGallery"
                data-testid="mobile-side-menu-button-mobile"
                class="material-icons"
                matTooltip="
                  Open Gallery
                "
              >
                <mat-icon>arrow_drop_up</mat-icon>
              </button>
            </div>
          </div>
        }
      }

      <!-- Menu -->
      <div class="button-wrapper">
        <div
          class="fab-icon-holder"
          [ngClass]="{ 'engaged-button': sideSectionService.sideContainerType === sideContainerType.ACTION_MENU }"
        >
          <button
            title="Actions Menu"
            mat-mini-fab
            id="btnMobileSideMenuBar"
            data-testid="mobile-side-menu-button"
            class="material-icons"
            (click)="toggleMenu()"
            [matTooltip]="
              sideSectionService.sideContainerType === sideContainerType.ACTION_MENU ? 'Close Menu' : 'Open Menu'
            "
          >
            <mat-icon svgIcon="MENU_MOBILE" class="menu-button"></mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
